import React from "react";
import { RMDReportContainer } from "../../../containers";

const MissedRMDReport = (props) => {
  const isMissed = true;
  console.log("hello", isMissed);

  return <RMDReportContainer {...props} isMissed={isMissed} />;
};

export default MissedRMDReport;
